import TrainplanetApi from "@/services/trainplanet.api";
import { createStore } from "vuex";
import order from "./modules/order";
import organization from "./modules/organization";

export function setTenantDocumentProperties(tenant) {
  const r = document.querySelector(":root");
  r.style.setProperty("--primary-color", tenant.theme.mainColor);
  r.style.setProperty("--secondary-color", tenant.theme.secondaryColor);
  r.style.setProperty("--action-color", tenant.theme.actionColor);
  r.style.setProperty("--warning-color", tenant.theme.warningColor);
  r.style.setProperty("--muted-color", tenant.theme.mutedColor);
  r.style.setProperty("--dark-color", tenant.theme.darkColor);
  r.style.setProperty("--header-color", tenant.theme.headerColor);
  r.style.setProperty("--header-title-color", tenant.theme.headerTitleColor);
  r.style.setProperty("--title-color", tenant.theme.titleColor);
  r.style.setProperty("--title-bg-color", tenant.theme.titleBackgroundColor);
  r.style.setProperty("--filter", tenant.theme.mainColorSvgFilters);
  r.style.setProperty(
    "--filter-secondary",
    tenant.theme.secondaryColorSvgFilters
  );
  r.style.setProperty("--widget-bg-color", tenant.theme.mainColor || "");
  r.style.setProperty("--widget-section-color", tenant.theme.section || "");
  if (tenant.name) document.title = tenant.name;
  const favicon = document.getElementById("favicon");
  if (favicon && tenant.theme.favIconUrl)
    favicon.href = tenant.theme.favIconUrl;
}

export default createStore({
  state: {
    tenant: {},
    offerMode: false,
  },

  getters: {
    tenant: (state) => state.tenant,
    offerMode: (state) => state.offerMode,
  },
  mutations: {
    setOfferMode(state, value) {
      state.offerMode = value;
    },
    setTenant(state, tenant) {
      if (tenant && tenant.id !== state.tenant?.id) {
        state.tenant = tenant;
        setTenantDocumentProperties(tenant);
      }
    },
  },
  actions: {
    async setTenant({ commit }) {
      const tenant = await TrainplanetApi.getTenant();
      commit("setTenant", tenant);
    },
  },
  modules: {
    order,
    organization,
  },
});
